// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__KViWQ","navsub":"Nav_navsub__3mRHv"};